import React from 'react'
import { Checkbox, CheckboxProps, Flex, Stack } from '@chakra-ui/core'
import { useField } from 'formik'
import { Text } from '../../../typography'
import { LabelProps } from '../styles'

export type ConnectedCheckboxGroupProps = LabelProps &
  CheckboxProps & {
    label?: string
    name: string
    options: { label: string; value: string }[]
  }

const ConnectedCheckboxGroup: React.FC<ConnectedCheckboxGroupProps> = ({
  label,
  options,
  ...rest
}) => {
  const [field, meta] = useField(rest.name)
  const [values, setValues] = React.useState<string[]>(field.value || [])
  return (
    <Flex
      mb={rest.mb}
      ml={rest.ml}
      mr={rest.mr}
      mt={rest.mt}
      justify={rest.justifyContent}
      direction="column"
    >
      {label && (
        <Text mb={2} fontSize="sm">
          {label}
        </Text>
      )}
      <Stack>
        {options.map((option) => {
          const isChecked = values?.includes(option?.value)
          return (
            <Checkbox
              key={option?.value}
              value={option?.value}
              isChecked={isChecked}
              variantColor="green"
              p={3}
              size="md"
              w="fit-content"
              bg={isChecked ? 'green.100' : 'gray.50'}
              border="1px solid"
              borderColor={isChecked ? 'green.50' : 'transparent'}
              borderRadius="lg"
              onChange={(e) => {
                const newValues = e.target.checked
                  ? [...values, option?.value]
                  : values.filter((v) => v !== option?.value)
                setValues(newValues)
                field.onChange({
                  target: { name: field.name, value: newValues }
                })
              }}
              {...rest}
            >
              <Text fontSize="xs" color="gray.700" fontWeight="bold">
                {option?.label}
              </Text>
            </Checkbox>
          )
        })}
      </Stack>
      {meta.touched && meta.error ? (
        <Text color="red.500" fontSize="xs">
          {meta.error}
        </Text>
      ) : null}
    </Flex>
  )
}

export default ConnectedCheckboxGroup
